


import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const isCalendarPage = false;
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    { label: 'Home Page', path: '/' },
    { label: 'Task', path: '/task' },
    { label: 'Classes', path: '/classes' },
    { label: 'Calendar', path: '/calendar' }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${isCalendarPage ? 'bg-darkslate text-white border-zinc-700' : 'bg-[#ecece9] text-gray-800 border-gray-200'}`}>
        <div className="w-full px-4 sm:px-6 lg:px-12">
          <div className="flex justify-between items-center py-4">
            
            {/* Logo */}
            <a href="/" className="group flex items-center">
              <div className="relative">
                <span className={`text-2xl sm:text-3xl lg:text-4xl font-bold tracking-wide ${isCalendarPage ? 'text-white' : 'text-gray-800'}`} style={{ fontFamily: 'Inter, system-ui, -apple-system, sans-serif' }}>
                  <span className="inline-block hover:transform hover:scale-105 transition-all duration-300">Synap</span>
                  <span className={`inline-block font-light ${isCalendarPage ? 'text-green-400' : 'text-green-600'} hover:transform hover:scale-105 transition-all duration-300`}>Sync</span>
                </span>
                {/* <div className={`absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r ${isCalendarPage ? 'from-blue-400 via-purple-400 to-blue-400' : 'from-blue-500 via-purple-500 to-blue-500'} opacity-70 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}></div> */}
                <div className={`absolute -top-1 -right-1 w-2 h-2 ${isCalendarPage ? 'bg-green-400' : 'bg-green-500'} rounded-full opacity-60 animate-pulse`}></div>
              </div>
            </a>

            {/* Desktop Navigation Links */}
            <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
              {navigationItems.map((item, index) => (
                <NavLink
                  key={index}
                  to={item.path}
                  className={({ isActive }) =>
                    `px-3 xl:px-4 py-2 rounded-lg font-medium transition-all duration-200 text-sm xl:text-base ${
                      isActive
                        ? `${isCalendarPage ? 'bg-white text-black' : 'bg-gray-900 text-white'} shadow-sm`
                        : `${isCalendarPage ? 'text-gray-300 hover:bg-zinc-800 hover:text-white' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'}`
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden">
              <button 
                onClick={toggleMobileMenu}
                className={`p-2 rounded-md transition-colors ${isCalendarPage ? 'text-white hover:bg-zinc-800' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'}`}
                aria-label="Toggle mobile menu"
              >
                {isMobileMenuOpen ? (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                ) : (
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`lg:hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen 
            ? 'max-h-64 opacity-100' 
            : 'max-h-0 opacity-0 overflow-hidden'
        }`}>
          <div className={`border-t ${isCalendarPage ? 'border-zinc-700 bg-darkslate' : 'border-gray-200 bg-[#ecece9]'}`}>
            <div className="px-4 py-2 space-y-1">
              {navigationItems.map((item, index) => (
                <NavLink
                  key={index}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={({ isActive }) =>
                    `block px-4 py-3 rounded-lg font-medium transition-all duration-200 ${
                      isActive
                        ? `${isCalendarPage ? 'bg-white text-black' : 'bg-gray-900 text-white'} shadow-sm`
                        : `${isCalendarPage ? 'text-gray-300 hover:bg-zinc-800 hover:text-white' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-200'}`
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default Navbar;